export const TEMPLATES_NODES_FILTER = [
	'n8n-nodes-base.manualTrigger',
	'n8n-nodes-base.respondToWebhook',
];
